import {
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaTools,
  FaBook,
  FaAward,
} from "react-icons/fa";

export interface Language {
  name: string;
  level: string;
  percentage: number;
}

export interface SoftSkill {
  name: string;
  icon: typeof FaUsers;
}

export const LANGUAGES: Language[] = [
  { name: "English", level: "Professional", percentage: 85 },
  { name: "Ukrainian", level: "Native", percentage: 100 },
  { name: "Russian", level: "Native", percentage: 100 },
];

export const SOFT_SKILLS: SoftSkill[] = [
  { name: "Leadership & Team Management", icon: FaUsers },
  { name: "Problem Solving & Critical Thinking", icon: FaLightbulb },
  { name: "Communication & Collaboration", icon: FaChartLine },
  { name: "Agile & Scrum Methodologies", icon: FaTools },
  { name: "Mentoring & Knowledge Sharing", icon: FaBook },
  { name: "Time Management & Prioritization", icon: FaAward },
];
